<template>
  <section id="main-contents">
    <div class="main-list">
      <div class="content-header">
        <div class="content-title">
          <h1>企業マスタ</h1>
        </div>
        <btn-create path="company"></btn-create>
      </div>
      <div class="content-row">
        <div class="count">
          データ総数：{{ this.count }}
        </div>
        <div class="pager">
          <span @click="pageMinus">＜</span>
          <input id="page-number" type="number" min="1" :max="max_page" step="1" v-model="this.page"
                 v-on:change="changePage">
          <span @click="pagePlus">＞</span>
        </div>
        <div class="limit">
          <ul>
            <li v-on:click="setLimit(10)">10</li>
            <li v-on:click="setLimit(15)">15</li>
            <li v-on:click="setLimit(20)">20</li>
          </ul>
        </div>
      </div>
      <table>
        <thead>
        <th v-on:click="sortc('id')">ID</th>
        <th v-on:click="sortc('name')">企業名</th>
        <th v-on:click="sortc('activated')">有効フラグ</th>
        <th v-on:click="sortc('updated_by')">更新者</th>
        <th v-on:click="sortc('updated_at')">更新日時</th>
        <th></th>
        </thead>
        <tbody>
        <tr v-for="(v) in list" v-bind:key="v.key">
          <td>{{ v.ID }}</td>
          <td>{{ v.Name }}</td>
          <td>{{ actText(v.Activated) }}</td>
          <td>{{ v.UpdatedName }}</td>
          <td>{{ displayDate(v.UpdatedAt) }}</td>
          <td><button class="btn edit" v-on:click="toDetail(v.ID)">編集</button> </td>
        </tr>
        </tbody>
      </table>
    </div>

  </section>
</template>

<script>
import axios from "axios";
import TimeFormatter from "@/script/TimeFormatter";
import BtnCreate from "@/components/BtnCreate";
import authCheck from "@/script/AuthCheck";

export default {
  name: 'MainCompany',
  components: {BtnCreate},
  props: {},
  data: function () {
    return {
      list: null,
      path: '/companies',
      detailPath: '/company',
      count: 0,
      page: 1,
      max_page: 1,
      limit: 20,
      direction: 'DESC',
      sort: 'id'
    }
  },
  created: function () {
    let path = this.path + '?page=' + this.page + '&limit=' + this.limit
    axios.get(path, {withCredentials: true})
        .then(res => {
          const router = this.$router
          authCheck(res, router)
          this.list = res.data.list
          this.count = res.data.count["Count"]
          this.max_page = res.data.maxPage
        })
        .catch(function (error) {
          console.log(error)
        })
  },
  computed: {

  },
  methods: {
    toDetail: function (id){
      this.$router.push(this.detailPath + '?id=' + id)
    },
    actText: function (flag){
      if(flag === 1){
        return "有効"
      }else if(flag === 2){
        return "無効"
      }
      return ""
    },
    displayDate: function (timestamp){
      return TimeFormatter(timestamp)
    },
    changePage: function () {
      if(this.page < 1){
        this.page = 1
      }
      if(this.page > this.max_page){
        this.page = this.max_page
      }
      this.pagerJump()
    },
    pageMinus: function () {
      if (this.page > 1) {
        this.page--
        this.pagerJump()
      }else{
        this.page = 1
      }
    },
    pagePlus: function () {
      if (this.page < this.max_page) {
        this.page++
        this.pagerJump()
      }else{
        this.page = this.max_page
      }
    },
    pagerJump: function () {
      let path = this.path +
          '?page=' + this.page +
          '&limit=' + this.limit +
          '&sort=' + this.sort +
          '&direction=' + this.direction
      this.$router.push(path)
      axios.get(path, {withCredentials: true})
          .then(res => {
            this.list = res.data.list
            this.max_page = res.data.maxPage
          })
          .catch(function (error) {
            console.log(error)
          })
    },
    setLimit: function (limit) {
      this.page = 1
      this.limit = limit
      this.pagerJump()
    },
    sortc: function (column) {
      if(this.sort === column){
        this.toggleDirect()
        this.sort = column
      }else{
        this.sort = column
        this.direction = 'DESC'
      }
      this.page = 1
      this.pagerJump()
    },
    toggleDirect:function (){
      if(this.direction === 'DESC'){
        this.direction = 'ASC'
      }else{
        this.direction = 'DESC'
      }
    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
